import { render, staticRenderFns } from "./BackerCenterPaymentsCard.vue?vue&type=template&id=0f488e20"
import script from "./BackerCenterPaymentsCard.vue?vue&type=script&lang=js"
export * from "./BackerCenterPaymentsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports